import { useForm, Link } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function ResendConfirmation({ email = '', errors: serverErrors = {} }) {
  const { data, setData, post, processing, errors } = useForm({ user: { email } })
  const allErrors = { ...serverErrors, ...errors }

  function handleSubmit(e) {
    e.preventDefault()
    post('/confirmation')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-600">Gosellgo</h1>
          <p className="mt-2 text-gray-600">Skicka nytt bekräftelsemail</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="E-post" error={allErrors.email}>
              <input
                type="email"
                value={data.user.email}
                onChange={e => setData('user', { email: e.target.value })}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                autoComplete="email"
              />
            </FormField>

            <Button type="submit" disabled={processing} className="w-full">
              {processing ? 'Skickar…' : 'Skicka bekräftelsemail'}
            </Button>
          </form>

          <p className="mt-6 text-center text-sm text-gray-600">
            Har du redan ett bekräftat konto?{' '}
            <Link href="/sign_in" className="text-indigo-600 hover:underline">
              Logga in
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
